import { useMutation } from "@tanstack/react-query";
import { logout } from "../api/logout";

export const LOGOUT_MUTATION_KEY = "logout";

export function useLogout() {
  const { mutateAsync } = useMutation({
    mutationKey: [LOGOUT_MUTATION_KEY],
    mutationFn: logout,
  });

  return {
    logout: mutateAsync,
  };
}
